<template>
  <div class="page">
        <!-- 搜索 -->
<!--  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>-->
<!--              <el-form-item label="资料">-->
<!--                  <el-input  v-model="queryForm.merterialId"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item>-->
<!--                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEduCourseCharpterMerterialList">查询</el-button>-->
<!--                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>-->
<!--              </el-form-item>-->
<!--  </el-form>-->
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addEduCourseCharpterMerterial"
        >新建</el-button>
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editEduCourseCharpterMerterial(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEduCourseCharpterMerterial(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
<!--        <span-->
<!--          title="搜索"-->
<!--          class="icon-box"-->
<!--          @click="search"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <Search />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportEduCourseCharpterMerterialList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshEduCourseCharpterMerterialList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="eduCourseCharpterMerterialList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="charpterId"-->
<!--        label="章节"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="merterialId"-->
<!--        label="资料"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="merterial.fileName"
            label="文件名称"
        > </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="merterial.fileUrl"
            label="文件URL"
        > </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="merterial.fileTag"
            label="文件标签"
        > </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="sort"
            label="排序"
        > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
<!--            <div @click="checkEduCourseCharpterMerterial(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Eye24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">查看</span>-->
<!--            </div>-->
<!--            <div @click="editEduCourseCharpterMerterial(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="deleteEduCourseCharpterMerterial(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="eduCourseCharpterMerterialStates[eduCourseCharpterMerterialState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
      :append-to-body="true"
    >
      <div>
        <el-form
          :model="eduCourseCharpterMerterial"
          ref="eduCourseCharpterMerterialForm"
          :rules="rules"
          label-width="60px"
          :inline="true"
          size="small"
        >
<!--          <el-form-item-->
<!--            label=""-->
<!--            prop="id"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="eduCourseCharpterMerterial.id"-->
<!--              :disabled="eduCourseCharpterMerterialState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item-->
<!--            label="章节"-->
<!--            prop="charpterId"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduCourseCharpterMerterial.charpterId"-->
<!--              :disabled="eduCourseCharpterMerterialState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="资料"
            prop="merterialId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduCourseCharpterMerterial.merterialId"-->
<!--              :disabled="eduCourseCharpterMerterialState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" title="选择资料" labelName="fileName" :disabled="eduCourseCharpterMerterialState == 'check'"
                           labelValue="id" :value="eduCourseCharpterMerterial.merterialId" :limit='1' size='small' placeholder='请选择资料'
                           @getValue="getValueUser" :columns="EDUCLASSMERTERIAL_code" :searchs="EDUCLASSMERTERIAL_search" dataListUrl="/edu/coursemerterial/findList" entityBeanName="eduCourseMerterial" queryEntityUrl="/edu/coursemerterial/get">
              </GridSelectU>
          </el-form-item>
            <el-form-item
              label="排序"
              prop="sort"
            >
                <el-input-number
                    style="width: 177px"
                    :disabled="eduCourseCharpterMerterialState == 'check'"
                    v-model="eduCourseCharpterMerterial.sort"
                    size="small"
                    label=""
                    :min="1"
                    :max="100000"
                    :step="1"
                    :controls="true"
                    controls-position="both"
                >
                </el-input-number>
            </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="eduCourseCharpterMerterialState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { EDUCLASSMERTERIAL, EDUCLASSMERTERIAL_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEduCourseCharpterMerterialList();
                    this.getEduCourseCharpterMerterialList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEduCourseCharpterMerterialList();
                    this.getEduCourseCharpterMerterialList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     charpterId: '', //章节
                     merterialId: '', //资料
                },
                EDUCLASSMERTERIAL_code: EDUCLASSMERTERIAL,
                EDUCLASSMERTERIAL_search: EDUCLASSMERTERIAL_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                eduCourseCharpterMerterialState: 'add',
                eduCourseCharpterMerterialStates: {
                    add: '新建章节资料',
                    check: '查看章节资料',
                    edit: '修改章节资料'
                },
                multipleSelection: [],
                eduCourseCharpterMerterialList: [],
                eduCourseCharpterMerterial: {
                    id: '', //
                    charpterId: '', //章节
                    merterialId: '', //资料
                    sort: 1
                },
                btnLoading: false,

                rules: {
                    charpterId: [{ required: true, message: '章节不能为空', trigger: 'blur' }],
                    merterialId: [{ required: true, message: '资料不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '章节排序不能为空', trigger: 'blur' }]
                }
            };
        },
        created() {

        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getValueUser(val){
                this.eduCourseCharpterMerterial.merterialId = val;
            },
            init(val){
                this.queryForm.charpterId = val;
                this.eduCourseCharpterMerterial.charpterId = val;
                this.getEduCourseCharpterMerterialList();
            },
            resetEduCourseCharpterMerterialList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.eduCourseCharpterMerterialList = [];
            },
            resetDialog() {
                this.eduCourseCharpterMerterialState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      charpterId: this.queryForm.charpterId, //章节
                      merterialId: '', //资料
                };
                this.getEduCourseCharpterMerterialList();
            },
            closeDialog() {
                this.showDialog = false
                this.eduCourseCharpterMerterial = {
                      id: '', //
                      charpterId: this.eduCourseCharpterMerterial.charpterId, //章节
                      merterialId: '', //资料
                      sort: 1
                };
            },
            submitForm() {
                if (this.eduCourseCharpterMerterialState == 'add') {
                    this.$refs.eduCourseCharpterMerterialForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/coursecharptermerterial/add`,{ ...this.eduCourseCharpterMerterial }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEduCourseCharpterMerterialList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.eduCourseCharpterMerterialState == 'edit') {
                    this.$refs.eduCourseCharpterMerterialForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.eduCourseCharpterMerterial.merterial;
                            post(`/edu/coursecharptermerterial/edit`,{ ...this.eduCourseCharpterMerterial }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEduCourseCharpterMerterialList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEduCourseCharpterMerterial() {
                this.showDialog = true;
                this.eduCourseCharpterMerterialState = 'add';
            },
            checkEduCourseCharpterMerterial(eduCourseCharpterMerterialId) {
                console.log(eduCourseCharpterMerterialId);
                this.currentEduCourseCharpterMerterialId = eduCourseCharpterMerterialId;

                this.getEduCourseCharpterMerterialById();
                this.showDialog = true;
                this.eduCourseCharpterMerterialState = 'check';
            },
            editEduCourseCharpterMerterial(eduCourseCharpterMerterialId) {
                console.log('eduCourseCharpterMerterial', eduCourseCharpterMerterialId);
                if (eduCourseCharpterMerterialId) {
                    this.currentEduCourseCharpterMerterialId = eduCourseCharpterMerterialId;
                    this.getEduCourseCharpterMerterialById();
                } else {
                    this.eduCourseCharpterMerterial = { ...this.eduCourseCharpterMerterial, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.eduCourseCharpterMerterialState = 'edit';
            },
            deleteEduCourseCharpterMerterial(eduCourseCharpterMerterialId) {
                let ids = '';
                if (eduCourseCharpterMerterialId) {
                    ids = eduCourseCharpterMerterialId;
                } else {
                    ids = this.multipleSelection.map((eduCourseCharpterMerterial) => eduCourseCharpterMerterial.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/edu/coursecharptermerterial/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduCourseCharpterMerterialList();
                                this.getEduCourseCharpterMerterialList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEduCourseCharpterMerterialList() {
                this.resetEduCourseCharpterMerterialList();
                this.getEduCourseCharpterMerterialList();
            },
            getEduCourseCharpterMerterialList(query = {}) {
                this.loading = true;
                get(`/edu/coursecharptermerterial/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.eduCourseCharpterMerterialList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEduCourseCharpterMerterialById() {
                get(`/edu/coursecharptermerterial/get`,{ id: this.currentEduCourseCharpterMerterialId }).then((res) =>{
                    if(res.success){
                      this.eduCourseCharpterMerterial = { ...this.eduCourseCharpterMerterial, ...res.eduCourseCharpterMerterial };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEduCourseCharpterMerterialList() {
                //this.btnLoading = true;
                exprotExcel(`/edu/coursecharptermerterial/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/edu/coursecharptermerterial/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/edu/coursecharptermerterial/importData`,formData);
              this.refreshEduCourseCharpterMerterialList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEduCourseCharpterMerterialList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEduCourseCharpterMerterialList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>